<template>
  <div>
    <div>
      <v-card dense>
        <v-card-title class="secondary">
          <span class="subtitle white--text">Re-Open</span>
          <v-spacer></v-spacer>
          <v-icon class="white--text" @click="orgDialoge()">mdi-close</v-icon>
        </v-card-title>
        <v-container fluid>
          <div>
            <b>Assign To:</b>
            {{ rowdetails.surveyor_name }}
          </div>

          <v-textarea
            color="teal"
            v-model="serveyorNotes"
            :counter="4000"
            :maxlength="max"
            label="Surveyor Notes"
          ></v-textarea>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary accent-4"
              :loading="loading"
              :disabled="loading"
              @click="assignSurveryorToSurvey()"
            >Submit</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </div>
    <div>
      <v-snackbar
        v-model="alertPositive"
        color="secondary"
        :timeout="timeout"
        bottom="bottom"
      >{{ text }}</v-snackbar>
      <v-snackbar
        v-model="alertNegetive"
        color="primary"
        :timeout="timeout"
        bottom="bottom"
      >{{ text }}</v-snackbar>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["rowdetails"],
  created: function() {
    console.log("hhhhhhhhhhhhhhhhh", this.rowdetails);
  },
  data() {
    return {
      max: 4000,
      alertPositive: false,
      alertNegetive: false,
      serveyorNotes: "",
      loading: false,
      timeout: 1700,
      text: ""
    };
  },
  methods: {
    async assignSurveryorToSurvey() {
      this.loading = true;
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "AssignSurveryer_assignSurveryorToSurvey",
        input: {
          surveynotes: this.serveyorNotes,
          surveyid: this.rowdetails.survey_id,
          orgid: this.rowdetails.orgid,
          surveyorid: this.rowdetails.surveyor_id
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        var assignSurvery = res.data.data.data;
        if (assignSurvery == "Success") {
          this.text = "Re-open Succesfully";
          this.$emit("alertSuccess", this.text);
          this.serveyorNotes = "";

          this.$emit("backEdit");
          this.loading = false;
        } else {
          this.text = "Error";
          this.$emit("alertError", this.text);
          this.alertNegetive = true;
          this.serveyorNotes = "";

          this.$emit("backEdit");
          this.loading = false;
        }
      } catch (error) {
        return error.response;
      }
    }
  }
};
</script>
